import { useSelector } from 'react-redux';

// Models
import { AuthClient } from 'app/modules/session/models';
import { PopoverSectionProps } from 'app/modules/navigator/models';

// Components
import { AccountPopoverSection } from 'app/modules/navigator/components/AccountPopoverSection';
import { IconUserX, IconUsers } from '@u21/tabler-icons';
import { U21Divider } from 'app/shared/u21-ui/components';

// Selectors
import {
  selectCanImpersonate,
  selectIsImpersonating,
} from 'app/modules/session/selectors';

// Utils
import { useCancelImpersonation } from 'app/modules/impersonation/queries/useCancelImpersonation';
import styled from 'styled-components';

interface Props extends PopoverSectionProps {
  auth: AuthClient;
  onOpenImpersonationModal: () => void;
}

function AccountImpersonateDropdown({
  auth,
  closePopover,
  onOpenImpersonationModal,
}: Props) {
  const canImpersonate = useSelector(selectCanImpersonate);
  const isImpersonating = useSelector(selectIsImpersonating);

  const { mutate: cancelImpersonation } = useCancelImpersonation(auth);

  const items = isImpersonating
    ? [
        {
          icon: <IconUserX />,
          key: 'impersonate',
          onClick: () => cancelImpersonation(),
          text: 'Cancel impersonation',
        },
      ]
    : [
        {
          icon: <IconUsers />,
          key: 'impersonate',
          onClick: onOpenImpersonationModal,
          text: 'Impersonate',
        },
      ];

  if (canImpersonate || isImpersonating) {
    return (
      <>
        <StyledU21Divider horizontal />
        <AccountPopoverSection
          closePopover={closePopover}
          items={items}
          title="Impersonate"
        />
      </>
    );
  }

  return null;
}

const StyledU21Divider = styled(U21Divider)`
  margin: 8px 0;
`;

export default AccountImpersonateDropdown;
